import { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import SelectSearchable from '../SelectSeachble/SelectSearchble';
import DatosCliente from './Crear/DatosCliente';
import AvisoDatoFaltante from './Crear/AvisoDatoFaltante';
import { GetTokenDecoded } from '../../utils/storeUsuario';
import { ListarPacientes } from '../../Service/Service.paciente';
import { useDispatch } from 'react-redux';
import { agregarCabeceraFactura } from '../../redux/actions';
import { tituloClinico } from '../../utils/textoClinico';

// FACTURACION-ASEGURADORAS-DETALLE-RIDE-FLUJO-08 (Problema B / deliverable H):
// se retira de la UI el segmento "Seguro". Facturar directamente a una
// aseguradora desde "Crear factura" saltaba el cálculo de copago server-side,
// el puente facturas_detalle_procedimientos y la trazabilidad de cartera; el
// flujo canónico de FAC a aseguradora es
//   Facturas → Listar por cobrar → Pendiente de facturar → Facturar aseguradora.
// El backend (POST /billing con seguro_id) NO se toca: sólo se oculta el tab
// y su estado exclusivo en el frontend.
// FACTURA-UI FASE 2: cambia SOLO como se pinta. La carga de pacientes, el
// manejador de seleccion y el `dispatch(agregarCabeceraFactura(...))` quedan
// exactamente como estaban -- si alguno se comportara distinto seria un error,
// no una mejora.
function ListaClienteSeguro() {

    const dispatch = useDispatch();

    const [pacientes, setPacientes] = useState([]);
    const [selectedPacienteOption, setSelectedPacienteOption] = useState(null);
    const [detailsSelectInfo, setDetailsSelectInfo] = useState(null);

    const fetchInitialData = useCallback(async () => {
        const tokenDecoded = GetTokenDecoded();
        const rPaciente = await ListarPacientes(tokenDecoded.idclinica);
        if (rPaciente && rPaciente.success) {
            /* Title Case en el LABEL, que es lo unico que se pinta -- dentro
               del selector y en cada opcion del desplegable. El dato original
               viaja intacto: `...pac` conserva `nombres_completos` tal cual, y
               el manejador resuelve el paciente por `value` (el id), no por el
               texto. `searchLabel` guarda el nombre CRUDO para que buscar en
               MAYUSCULAS siga encontrando. */
            const pacientes = rPaciente.data.map((pac) => ({
                value: pac.idpaciente,
                label: tituloClinico(pac.nombres_completos || ""),
                searchLabel: `${pac.nombres_completos || ""} ${pac.cedula || ""}`,
                ...pac,
            }));
            setPacientes(pacientes)
        }
    }, []);

    const handlePacienteChange = selectedOption => {
        setSelectedPacienteOption(selectedOption);

        if (selectedOption) {
            var pacienteSeleccionado = pacientes.filter(a => a.idpaciente === selectedOption.value);
            setDetailsSelectInfo(pacienteSeleccionado[0]);
            dispatch(agregarCabeceraFactura({ paciente: pacienteSeleccionado[0] }));
        }
    };

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    // Sin paciente, el buscador ocupa todo el ancho y se explica: una fila de
    // etiquetas vacias no le dice nada a nadie.
    const cobertura =
        detailsSelectInfo?.seguros?.nombre ||
        detailsSelectInfo?.tipo_seguros?.tipo ||
        "";

    return (
        <>
            <Row className="pt-2">
                <Col sm={detailsSelectInfo ? 4 : 12}>
                    <div className="w-auto">
                        <SelectSearchable
                            listCompany={pacientes}
                            handleChange={handlePacienteChange}
                            placeholder="Seleccione Paciente"
                            selectedOption={selectedPacienteOption}
                            conIconoBuscar
                        />
                    </div>
                    {!detailsSelectInfo && (
                        <p className="fcrear__ayuda">
                            Busca al paciente por nombre o cedula para empezar la factura.
                        </p>
                    )}
                </Col>
                {detailsSelectInfo && (
                    <Col sm={8}>
                        <DatosCliente info={detailsSelectInfo} cobertura={cobertura} />
                    </Col>
                )}
            </Row>

            <AvisoDatoFaltante info={detailsSelectInfo} />
        </>
    )
}

export default ListaClienteSeguro
